module.exports = __webpack_public_path__ + "static/img/shuili_2.c95129f9.png";